import React, { forwardRef } from 'react';
import cn from 'classnames';
import BaseButton from './BaseButton';

const DisableButton = forwardRef(({ title = 'Disable', className, ...props }, ref) => {
  const btnClassName = cn('disable-button', { [className]: className });
  return (
    <BaseButton
      ref={ref}
      id='disable-button'
      responsive
      fillMode='outline'
      themeColor='error'
      className={btnClassName}
      icon='minus-circle'
      title={title}
      {...props}
    />
  );
});

export default DisableButton;
